export default __webpack_public_path__ + "static/media/pto-oa.52ca5255.svg";